/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetSBPPayloadQueryResponse, GetSBPPayloadQueryParams, GetSBPPayload400, GetSBPPayload401, GetSBPPayload404 } from "../entities/GetSBPPayload";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSBPPayload } from "../api/getSBPPayload";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSBPPayloadQueryKey = (params: GetSBPPayloadQueryParams) => [{ url: '/api/v1/payments/sbp' }, ...(params ? [params] : [])] as const

export type GetSBPPayloadQueryKey = ReturnType<typeof getSBPPayloadQueryKey>

export function getSBPPayloadQueryOptions(params: GetSBPPayloadQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSBPPayloadQueryKey(params)
        return queryOptions<GetSBPPayloadQueryResponse, ResponseErrorConfig<GetSBPPayload400 | GetSBPPayload401 | GetSBPPayload404>, GetSBPPayloadQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getSBPPayload(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получает payload для платежа через СБП. Платеж должен быть инициализирован через T-Bank.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - payment_id - идентификатор платежа в системе Т-Бизнес
 * **Процесс:**
 * 1. Валидация входных данных
 * 2. Проверка, что у пользователя есть аккаунт
 * 3. Получение payload для платежа через СБП
 * 4. Возврат payload для платежа через СБП
 * @summary Получение payload для платежа через СБП
 * {@link /api/v1/payments/sbp}
 */
export function useGetSBPPayload<TData = GetSBPPayloadQueryResponse, TQueryData = GetSBPPayloadQueryResponse, TQueryKey extends QueryKey = GetSBPPayloadQueryKey>(params: GetSBPPayloadQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetSBPPayloadQueryResponse, ResponseErrorConfig<GetSBPPayload400 | GetSBPPayload401 | GetSBPPayload404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getSBPPayloadQueryKey(params)
         

         const query = useQuery({
          ...getSBPPayloadQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetSBPPayload400 | GetSBPPayload401 | GetSBPPayload404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}